<mat-card id="card" fxLayout="column" class="mainContentBody">
  <mat-card-content fxFlex [style.overflow]="'auto'" fxLayout="column" class="mainContentBodyContent">

    <h2>Dettaglio Software</h2>
    <div fxLayout="column" class="responsive-mat-form">
      <form [formGroup]="form" fxLayout="column">
        <!-- Id field -->
        <mat-form-field>
          <input matInput formControlName="id" placeholder="Software Id" readonly="true" />
        </mat-form-field>

        <!-- nome field -->
        <mat-form-field fxlayout="column">
          <input matInput formControlName="nome" placeholder="Nome" />
          <mat-error *ngIf="form.get('nome').errors?.required">
            Campo obbligatorio
          </mat-error>
        </mat-form-field>

       <mat-form-field fxlayout="column">

        <mat-label>Tipologia Software</mat-label>
          <mat-select formControlName="tipologia">
            <mat-option *ngFor="let tipo of listaTipologie" [value]="tipo">
              {{ tipo }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('tipologia').errors?.required">
            Campo obbligatorio
          </mat-error>
      </mat-form-field>
        
        <!-- descrizione field -->
        <mat-form-field fxlayout="column">
          <input matInput formControlName="descrizione" placeholder="descrizione del software"/>
          <mat-error *ngIf="form.get('descrizione').errors?.required">
            Campo obbligatorio
          </mat-error>
        </mat-form-field>
        
        <!-- signInOutDescription field -->
        <!-- bisognerebbe mettere un limite di larghezza. -->
        <mat-form-field fxlayout="column">
          <input matInput formControlName="signInOutDescription" placeholder="signInOutDescription"/>
          <mat-error *ngIf="form.get('signInOutDescription').errors?.required">
            Campo obbligatorio
          </mat-error>
        </mat-form-field>
        
        <!-- modalitaAccesso field -->
        <mat-form-field fxlayout="column">
          <input matInput formControlName="modalitaAccesso" placeholder="modalitaAccesso"/>
          <mat-error *ngIf="form.get('modalitaAccesso').errors?.required">
            Campo obbligatorio
          </mat-error>
        </mat-form-field>
        
        <!-- utilizzatori field -->
        <mat-form-field fxlayout="column">
          <input matInput formControlName="utilizzatori" placeholder="utilizzatori"/>
          <mat-error *ngIf="form.get('utilizzatori').errors?.required">
            Campo obbligatorio
          </mat-error>
        </mat-form-field>
        
        <!-- trasferimentoDati field -->
        <mat-slide-toggle formControlName="trasferimentoDati" fxlayout="column">
          trasferimentoDati
        </mat-slide-toggle>

        <hr>

<div fxLayout="column" *ngIf="software.id">
    <h3>-- Dispositivi su cui è installato --</h3>

    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="deviceTableParams.dataSource">

            <ng-container matColumnDef="codiceCespite">
                <th mat-header-cell *matHeaderCellDef> Codice Cespite </th>
                <td mat-cell *matCellDef="let element"> {{element.codiceCespite}} </td>
            </ng-container>

            <ng-container matColumnDef="mac">
                <th mat-header-cell *matHeaderCellDef> Mac </th>
                <td mat-cell *matCellDef="let element"> {{element.mac}} </td>
            </ng-container>

            <ng-container matColumnDef="tipoId">
                <th mat-header-cell *matHeaderCellDef> Tipo </th>
                <td mat-cell *matCellDef="let element"> {{ element.tipo?.descrizione }} </td>
            </ng-container>

            <ng-container matColumnDef="collaboratore">
                <th mat-header-cell *matHeaderCellDef> Collaboratore </th>
                <td mat-cell *matCellDef="let element"> {{ element.collaboratore?.userName }} </td>
            </ng-container>

            <ng-container matColumnDef="detail">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                     <button mat-mini-fab color="primary" [routerLink]="['/device/detail/', element.id]">
                        <mat-icon>search</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="deviceTableParams.displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: deviceTableParams.displayedColumns;"></tr>
        </table>

        <mat-paginator [length]="deviceTableParams.length"
                       [pageSize]="deviceTableParams.pageSize"
                       [pageSizeOptions]="[5, 10, 20]"
                       (page)="setDevicePaginator($event)">
        </mat-paginator>
    </div>
</div>


        <!-- Campi di informazione operazione -->
        <mat-expansion-panel class="mat-elevation-z0">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Dettagli operazione
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div fxLayout="row">
            <!-- InsertDate field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
              [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
              [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
              <input matInput formControlName="insertDate" placeholder="Insert Date" readonly="true" />
            </mat-form-field>

            <!-- InsertUser field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
              <input matInput formControlName="insertUser" placeholder="Insert User" readonly="true" />
            </mat-form-field>
          </div>
          <div fxLayout="row">
            <!-- UpdateDate field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
              [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
              [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
              <input matInput formControlName="updateDate" placeholder="Update Date" readonly="true" />
            </mat-form-field>

            <!-- UpdateUser field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
              <input matInput formControlName="updateUser" placeholder="Update User" readonly="true" />
            </mat-form-field>
          </div>
        </mat-expansion-panel>
      </form>
    </div>
    <mat-card-actions>
      <button mat-raised-button (click)="backConfirm('/software')" color="primary">Back</button>
      <button mat-raised-button (click)="softwareSave()" [disabled]="form.invalid || !form.dirty"
        *ngIf="software?.deleteDate==null">Save</button>
      <button mat-raised-button (click)="softwareDelete()" [disabled]="software?.id==null"
        *ngIf="software?.deleteDate==null">Delete</button>
    </mat-card-actions>
  </mat-card-content>
</mat-card> 